var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"customSlides",staticClass:"custom-slider",style:({
    paddingLeft: _vm.paddingsForSlider,
    paddingRight: _vm.paddingsForSlider,
    overflowX: _vm.offsetStartPosition ? 'hidden': 'auto',
    gap: `${_vm.gap}px`,
  }),on:{"scrollend":_vm.scrollEnd}},_vm._l((_vm.items),function(item,index){return _c('div',{key:index,staticClass:"m-btn custom-slide"},[_vm._t("item",null,{"slide":item,"index":index})],2)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }